'use client';

import {
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
} from 'react';
import { UUID } from '@trucksmarter/shared';
import useSessionStorage from '@ui/shared/storage/useSessionStorage';

const LoadBoardViewedLoadIdsContext = createContext<ReadonlySet<UUID> | null>(
  null,
);

export function useViewedLoadIds() {
  return useContext(LoadBoardViewedLoadIdsContext);
}

const MarkLoadAsViewedInMemoryContext = createContext<
  ((id: UUID) => void) | null
>(null);

export function useMarkLoadAsViewedInMemory() {
  return useContext(MarkLoadAsViewedInMemoryContext);
}

export default function LoadBoardViewedLoadIdsProvider({
  children,
}: PropsWithChildren) {
  const [viewedLoadIds, setViewedLoadIds] = useSessionStorage<Set<UUID>>(
    'viewedLoadIds',
    new Set(),
  );

  const markLoadAsViewed = useCallback(
    (loadId: UUID) => setViewedLoadIds((prev) => new Set(prev).add(loadId)),
    [setViewedLoadIds],
  );

  return (
    <LoadBoardViewedLoadIdsContext.Provider value={viewedLoadIds}>
      <MarkLoadAsViewedInMemoryContext.Provider value={markLoadAsViewed}>
        {children}
      </MarkLoadAsViewedInMemoryContext.Provider>
    </LoadBoardViewedLoadIdsContext.Provider>
  );
}
